import { DataProvider } from 'react-admin'
import { TicketImportUpdateDto } from '../../dto/ticket-import-update.dto'

const fakeTicketImportUpdates: TicketImportUpdateDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({
      data: fakeTicketImportUpdates,
      total: fakeTicketImportUpdates.length,
    }),
} as DataProvider

export default provider
